import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useMemo, useRef, useState } from "preact/hooks";
import Checkbox from "./elements/Checkbox"
import RadioButton from "./elements/RadioButton"
import Icon from "./elements/Icon"
import FacetSearchBar from "./elements/FacetSearchBar"

export default function Facet({ facet, isInToolbar, openedFacetId, setOpenedFacetId }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);

    const isBrandFacet = facet?.field === "brand";
    const isSavingsAndOffersFacet = facet?.name === 'Savings & Offers';

    // should be changed on live
    // const isBrandFacet = facet?.id === "680a1490cd7b1a31eadd4c92";
    const refId = isInToolbar ? facet?.field : facet?.id;

    const [ searchFacet, setSearchFacet ] = useState("");
    const handleChange = (e) => {
        setSearchFacet(e.target.value)
    }

    const filteredFacets = facet?.data?.filter(facets =>{
        if (searchFacet === "") {
            return facet?.data;
        } else {
            if (facets.value.toLowerCase().includes(searchFacet.toLowerCase())) {
                return facets;
            }
        }
    })

    // useEffect(()=>{
    //     if(active && isInToolbar){
    //         toggleActive();
    //     }
    // }, [])

    useEffect(()=>{
        if(active && openedFacetId !== facet?.id){
            toggleActive();
        }
    }, [openedFacetId])

    function clickFacet() {
        if(isInToolbar){
            toggleActive();
            setOpenedFacetId(facet.id);
        } else {
            toggleActive();
        }
    }

    // new logic for clicking outside of the facet 
    const facetRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (facetRef.current && !facetRef.current.contains(event.target)) {
            if (active) {
              toggleActive();
              if (isInToolbar) {
                setOpenedFacetId(null);
              }
            }
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [active, toggleActive, isInToolbar, setOpenedFacetId]);

    // console.log(facet);
    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active} ref={facetRef}>
            <span
                class={`ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box ${!isInToolbar ? "ns-p-4" : ""}`}
                data-nosto-element="facet"
                // onClick={()=>{
                //     toggleActive();
                //     setOpenedFacetId(facet.id);
                // }}
                onClick={() => clickFacet()}
                aria-controls={`${refId}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-color-black ns-font-4 ns-font-bold">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17454922466190.8147754591327114" alt="Dropdown Icon" class="ns-dropdown-icon" aria-hidden="false" />
            </span>
            <div class="ns-sidebar-submenu ns-d-none" id={`${refId}-sub-menu`}>
                {isBrandFacet && <FacetSearchBar name={facet.name} handleChange={handleChange} />}
                <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-p-4" role="menu">
                    {filteredFacets.map(value => (
                        <li
                            key={value.value}
                            // ns-justify-content-between
                            class="ns-d-flex ns-align-items-center ns-font-5"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                isSavingsAndOffersFacet={isSavingsAndOffersFacet}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* ns-font-bold ns-font-3 ns-background-grey-light */}
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-color-black ns-border-radius-3">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
                {isInToolbar && (
                    <div class="ns-apply-btn-container ns-p-4">
                        <button class="ns-apply-btn" onClick={toggleActive}>View Results</button>
                    </div>
                )}
            </div>
        </li>
    )
}
